import React from 'react'
import ImagesPallet from '../../../utils/ImagesPallet'

function FirstSection() {
  return (
    <div 
      className="min-h-screen bg-center bg-cover bg-no-repeat relative justify-center items-center flex"
      style={{
        backgroundImage: "url('" + ImagesPallet.HeroAcademy + "')",
      }}
    >
      {/* Overlay gelap opsional untuk membuat konten lebih mudah dibaca */}
       <div className="absolute inset-0 bg-black/70" />
      
       {/* Konten section */}
       <div className="relative z-10 container mx-auto px-4">
         <div className="relative w-full h-72 flex justify-center items-center overflow-hidden mt-20">
            <div className="text-center animate-bounce ease-linear">
              <style>
                {`
                  @keyframes fadeIn {
                    from {
                      opacity: 0;
                      transform: translateY(20px);
                    }
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }
                  
                  .animate-fade-in {
                    animation: fadeIn 1.5s ease-out forwards;
                  }

                  .golden-text {
                    background: linear-gradient(
                      to bottom,
                      #A75B3B 0%,
                      #ffffff 50%,
                      #ffffff 100%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
                    letter-spacing: 0.05em;
                    font-family: "Arial Black", sans-serif;
                  }

                  .golden-text:hover {
                    background: linear-gradient(
                      to bottom,
                      #fff 0%,
                      #ffd700 50%,
                      #daa520 100%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    cursor: pointer;
                  }
                `}
              </style>
              <h1 className="sm:text-5xl md:text-6xl font-black mb-2 uppercase golden-text">
                welcome to 
              </h1>
              <h2 className="sm:text-5xl md:text-6xl font-black uppercase golden-text">
                papakilo academy
              </h2>
            </div>
          </div>
         
       </div>
    </div>
  )
}

export default FirstSection